export const Container = 'flex mb-4 flex-col md:flex-row'

export const Sections = 'w-full flex flex-col pb-6'

export const Headline = 'mb-4'

export const BottomLink = 'mt-6 w-moz-fit w-fit'

export const NoItem = 'text-14 text-black'

export const WishlistItem =
  'mr-1 md:mr-[10px] h-fit max-h-[40px] min-h-[30px] w-auto min-w-[30px] max-w-[40px] last-of-type:mr-0'

export const WishlistItemRemaining = `flex items-center justify-center text-blalck bg-silver font-bold w-[40px] h-[40px]`
